import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LoginService } from '../auth/login/login.service';

@Injectable({
  providedIn: 'root',
})
export class DiagnosisService {
  constructor(
    private http: HttpClient,
    public router: Router,
    private loginSvc: LoginService
  ) {}

  createDiagnosis(
    name: string,
    observaciones: string,
    sintoma: any,
    seccion: any,
    idTicket: number,
    sn: string
  ): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        name,
        observaciones,
        sintoma,
        seccion,
        idTicket,
        sn,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/create-diagnosis',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error de logo: ', err);

            observer.error(err);
          }
        );
    });
  }

  getSymptonCodes(proyecto: number): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyecto,
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-symptom-codes',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error descargando sympton codes: ', err);

            observer.error(err);
          }
        );
    });
  }

  getImagePasoCode(idPaso: number, idImagen: number): any {
    return new Observable<boolean>((observer) => {
      const body = {
        id: idPaso,
        idImagen,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-imagenes-pasos',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error de logo: ', err);

            observer.error(err);
          }
        );
    });
  }

  getSectionCodes(proyecto: number): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const body = {
        proyecto,
      };

      const accessToken = this.loginSvc.getAccessToken();

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/get-section-codes',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error getSectionCodes: ', err);

            observer.error(err);
          }
        );
    });
  }
}
